import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * Get the prices
 *
 * @param {Array} ids - the ids to check for prices against (empty array if want *all* supply)
 * @returns {object} the result data
 */
/* export default async function getPrices (ids = []) {
  return await fetchJSONData(`${constants.API_URL}/nft_element/price`, {
    method: 'POST',
    body: JSON.stringify({ nft_id: ids, network: constants.NETWORK }),
    headers: {
      'company-id': constants.API_ID,
      'Content-Type': 'application/json'
    }
  })
} */

/**
 * Get the prices
 *
 * @returns {object} the result data
 */
export default async function getPrices () {
  return await fetchJSONData(
    `${constants.API_URL}/nft_element/price?network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    }
  )
}
